import { defineMessages } from 'react-intl';

export default defineMessages({
    policyEffectiveDate: {
        id: "twia.quoteandbind.views.success-page.Policy Effective Date",
        defaultMessage: "Policy Effective Date"
    },
    requestedStartDate: {
        id: "twia.quoteandbind.views.success-page.Requested Coverage Start Date",
        defaultMessage: "Requested Coverage Start Date"
    },
    policyNumber: {
        id: "twia.quoteandbind.views.success-page.Policy Number",
        defaultMessage: "Policy Number"
    },
    offerNumber: {
        id: "twia.quoteandbind.views.success-page.Offer Number",
        defaultMessage: "Offer Number"
    },
    issuedMessage: {
        id: 'twia.quoteandbind.views.success-page.issuedMessage',
        defaultMessage: "The policy has been issued."
    },
    offerSubmittedMessage: {
        id: 'twia.quoteandbind.views.success-page.offerSubmittedMessage',
        defaultMessage: "TWIA has received this application. Coverage will be bound and a policy issued upon TWIA's receipt of payment. The applicant will receive an email with instructions on how to make a payment, if needed. This offer will expire in 30 days."
    },
    applicationContent: {
        id: 'twia.quoteandbind.views.success-page..confirmation.Application',
        defaultMessage: `
        •  Offer Letter and Payment Coupon
        •  Application`,
    },
    issuedApplicationContent: {
        id: 'twia.quoteandbind.views.success-page.confirmation.issuedapplicationContent',
        defaultMessage: `
        •  Declaration Page
        •  Policy Package
        •  Application`,
    },
})